import React, { useState } from "react";
import Notification from "./Notification";
import { langIconHeader } from "../icon_assets";
import BlurModal from "../CommonComponents/BlurModal/BlurModal";
import { isMobile } from "../helperFunc";
import SelectLangContent from "../Profile/SelectLangContent";

const RightPart = ({ login, notifications = [] }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="d-flex">
      <BlurModal
        show={show}
        onHide={() => setShow(false)}
        showDesktopHeader={!isMobile}
        desktopHeading="Select Language"
      >
        <SelectLangContent />
      </BlurModal>
      {/* <SearchComponent /> */}
      {notifications?.length > 0 ? (
        <Notification notifications={notifications} />
      ) : (
        ""
      )}
      <img
        alt=""
        src={langIconHeader}
        className={`margin-left16`}
        onClick={() => setShow(true)}
      />
    </div>
  );
};
export default RightPart;
